import { initializeApp } from 'firebase/app';
import { getFirestore, collection, getDocs, doc, updateDoc, deleteDoc, setDoc } from 'firebase/firestore';
import { getAuth } from "firebase/auth";
import { getStorage , ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyD0xuFqfhzDpUclEwvWe9K2YRVJg70UCxw",
  authDomain: "vest-truck.firebaseapp.com",
  projectId: "vest-truck",
  storageBucket: "vest-truck.firebasestorage.app",
  messagingSenderId: "564041001310",
  appId: "1:564041001310:web:56eed2f1c23f1ce86b87cf"
};

  export const app = initializeApp(firebaseConfig);
  export const firestore = getFirestore(app);
  export const auth = getAuth(app);
  export   const storage = getStorage(app);